module.exports = "<div ng-controller=\"ShellController as vmShell\"><ui-view></ui-view><footer ng-if=!embded.noHeader class=main-footer ng-include=\"'app/layout/footer.html'\"></footer></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/html-loader!./app/layout/shell.html
 ** module id = 224
 ** module chunks = 0
 **/